module.exports = __webpack_public_path__ + "static/media/call.5361f730.jpg";